import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import {
	IItemDetailList,
	IMaintenanceDetail,
	IMaterialDetailList,
	OtherItemDetailList
} from './MaintenanceType';
import { maintenanceService } from './MaintenanceService';
import { useGlobalModel } from "@/model/globalModel";

export const useMaintenanceDetailsModel = createModel(function () {
	const {
		getCiDictByDictCode
	} = useGlobalModel(() => []);

	//查看详情form
	const [tradeCode, setTradeCode] = useState<string>("");
	const [detailLookForm, setDetailLookForm] = useState<IMaintenanceDetail>({});

	//项目详情列表
	const [itemDetail, setItemDetail] = useState<IItemDetailList[]>([]);
	const [itemDetailVisible, setItemDetailVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [detailMaterialList, setDetailMaterialList] = useState<IMaterialDetailList[]>([]);
	const [detailMaterialListVisible, setDetailMaterialListVisible] = useState<boolean>(false);
	//维修用料详情列表
	const [otherItemDetailList, setOtherItemDetailList] = useState<OtherItemDetailList[]>([]);
	const [otherItemDetailListVisible, setOtherItemDetailListVisible] = useState<boolean>(false);

	//维修单信息
	const getDetailOne = async (id: any) => {
		let { retData } = await maintenanceService.one(id);
		if (retData != null) {
			const newFrom: IMaintenanceDetail = {
				...retData,
				repairContactName: (retData.senderRepairUserName ?? "") + " " + (retData.senderRepairUserPhone ?? ""),
				serviceMethod: getCiDictByDictCode(retData.serviceMethod)?.title,
				serviceType: getCiDictByDictCode(retData.serviceType)?.title,
				faultClassification: getCiDictByDictCode(retData.faultClassification)?.title,
				customerVehicleMileage: (retData.customerVehicleMileage ?? 0) + "  KM",
				mileage: (retData.mileage ?? 0) + "  KM",
				orderType: getCiDictByDictCode(retData.orderType)?.title,
			};
			setDetailLookForm(newFrom);

			setItemDetailVisible(false);
			setDetailMaterialListVisible(false);
			setOtherItemDetailListVisible(false);
			itemDetailList(retData.id as string);
			materialList(retData.id as string);
			otherItemList(retData.id as string);
		}
	};


	//维修项目
	const itemDetailList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003", "016004"] } };
		let { retData } = await maintenanceService.itemList(param);
		const { list } = retData;
		setItemDetail(list);
		if (list != null && list.length > 0) {
			setItemDetailVisible(true);
		}
	};

	//维修物料
	const materialList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id, "serviceNature": ["016002", "016003", "016004"] } }
		let { retData } = await maintenanceService.materialList(param);
		const { list } = retData;
		let newList = list.map(item => ({
			...item,
			totalCount: item.materialAmount,
			actualMoney: item.actualAmount,
			availableUseNum: (item.remainingNum ?? 0) + (item.materialNumber ?? 0),
		}));
		setDetailMaterialList(newList);

		if (list != null && list.length > 0) {
			setDetailMaterialListVisible(true);
		}
	};

	//其他项目
	const otherItemList = async (id: string) => {
		let param = { "pageSize": 1000, "searchItem": { "orderId": id } }
		let { retData } = await maintenanceService.otherItemDetailList(param);
		const { list } = retData;
		setOtherItemDetailList(list);

		if (list != null && list.length > 0) {
			setOtherItemDetailListVisible(true);
		}
	};


	return {
		setTradeCode,
		getDetailOne,
		tradeCode,
		detailLookForm,
		itemDetail,
		itemDetailVisible,
		detailMaterialList,
		detailMaterialListVisible,
		otherItemDetailList,
		otherItemDetailListVisible
	};

});
